/**
 *
 * @param {MainClassProps} main
 * @param {TriggerProps} trigger
 * @param {TimelineMapProps} timeline
 * @returns {Number}
 */
const getPercentsCoordinates = (main, trigger, timeline) => {
  /** Get percents function */
  const getPercents = /** @type {Function} */ (trigger.get("get-percents"));

  /** Percents number */
  const percents = /** @type {Number} */ (getPercents(main, trigger));

  /** Set overall timeline percents */
  timeline.set("percents-overall", percents);

  return percents;
};

export default getPercentsCoordinates;
